import React from 'react';
import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import './styles.scss';
export type DeleteModalType = 'archive' | 'delete' | 'restore' | 'move' | 'publish' | 'save';
type DeleteModalColorType = 'red' | 'none';

const DeleteModal = ({
  type = 'archive',
  show,
  onClose,
  handleDelete,
  title,
  description,
  loading,
  emoji = '😓',
  color = 'none'
}: {
  type?: DeleteModalType;
  show: boolean;
  onClose: (refetchData?: boolean) => void;
  handleDelete: () => void;
  title: string;
  description: string;
  loading?: boolean;
  emoji?: string;
  color?: DeleteModalColorType;
}) => {
  return (
    <BaseModal
      isOpen={show}
      title=''
      titleIcon={<AddIcon />}
      titleIconColor='gray'
      onRequestClose={() => onClose()}
      bodyOpenClassName='archive-modal'>
      <div className='archive-modal__content'>
        <div className={`mt-4 ${color == 'red' && 'archive-modal__secondlayer'}`}>
          <div className={`${color == 'red' && 'archive-modal__firstlayer'}`}>
            <p className={`${color == 'red' && 'archive-modal__emoji'}`}>{emoji}</p>
          </div>
        </div>

        <h4 className='archive-modal__title'>{title}</h4>
        <p className='archive-modal__desc'> {description}</p>

        <div className='archive-modal__btn'>
          <Button
            onClick={() => onClose()}
            color='gray'
            variant='block'
            small
            className='archive-modal__cancel'>
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            className='capitalize'
            color='primary'
            variant='block'
            loading={loading}
            small>
            {type}
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};

export default DeleteModal;
